module.exports = __webpack_public_path__ + "static/media/CainWhiteLogo.9c8453fa.png";